import { render, staticRenderFns } from "./modelTree.vue?vue&type=template&id=607d953a&scoped=true&lang=pug"
import script from "./modelTree.vue?vue&type=script&lang=js"
export * from "./modelTree.vue?vue&type=script&lang=js"
import style0 from "./modelTree.vue?vue&type=style&index=0&id=607d953a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d953a",
  null
  
)

export default component.exports